import { render, staticRenderFns } from "./IconBuilding.vue?vue&type=template&id=67ace3a6&"
import script from "./IconBuilding.vue?vue&type=script&lang=ts&"
export * from "./IconBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports